import { Brick, registerBrick, ErrorFlow } from 'olympe';
import { getLogger } from '@olympeio/core';
import * as _ from 'lodash';
import { getAsArray } from '../../helper';

export default class Includes extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} source
     * @param {*} value
     * @param {number} fromIndex
     * @param {function(*)} setResult
     * @param {function(*)} setErrorFlow
     */
    update($, [source, value, fromIndex], [setResult, setErrorFlow]) {
        const logger = getLogger('Includes');

        // Guards
        if (typeof fromIndex !== 'number') {
            logger.error('Provided fromIndex input is not a number');
            return;
        }

        const { array, error } = getAsArray(source);

        if (!error) {
            const index = _.includes(array, value, fromIndex);
            setResult(index);
        } else {
            logger.error(error.message);
            setErrorFlow(ErrorFlow.create(error.message, error.code));
        }
    }
}

registerBrick('017fe573306db4d59562', Includes);